import React from 'react';
import { View, Image, StyleSheet, Platform } from 'react-native';
import ImgSrc from '../../../assets/votl-logo-black.png';

const AppLogo = () => {
    return (
        <View style={styles.container}>
            {Platform.OS === 'web' ? (
                <img src={ImgSrc} width="300" height="300" />
            ) : (
                    <Image style={styles.image} source={ImgSrc} />

                )}
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
        alignItems: 'center',
        borderRadius: 4,
        marginBottom: 30,
    },
    image: {
        height: 240,
        resizeMode: 'contain',
    }
});

export default AppLogo;